import { gql } from '@apollo/client'

export const GIFT_CARD_FRAGMENT = gql`
  fragment GiftCardFields on ShopOrderGiftCard {
    id
    last4
    balanceFormatted
    initialBalanceFormatted
    designUrl
    note
  }
`
